import React from 'react';
import { OrderEntryMobileContent } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/containers/order-entry-mobile-content';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.OrderEntry
>;

export const OrderEntryMobileScreen: React.FC<Props> = ({ route }) => {
  const { restaurantUUID, supplierUUID } = route.params;

  return (
    <SalesHubShellTemplate>
      <OrderEntryMobileContent
        restaurantUUID={restaurantUUID}
        supplierUUID={supplierUUID}
      />
    </SalesHubShellTemplate>
  );
};
